import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPlanejamento(contratoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterHistorico(contratoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro/historico`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    aprovar(contratoId) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro/aprovar`, {})
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    devolver(contratoId, motivo) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/${contratoId}/planejamento-fisico-financeiro/devolver`, { motivoDevolucao: motivo })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
